import {req as aqfe_request} from "@/axios/aqfe"

export const FcstPublishedRepo = {
    get: (query) => aqfe_request("get", 'fcst_published/', query)

}